<template>
  <VideoPlayer class="lesson-section-video" :src="data.video.url" />
</template>

<script>
import VideoPlayer from '../../media/VideoPlayer'

export default {
  name: 'LessonSectionVideo',
  components: { VideoPlayer },
  props: { data: Object },
}
</script>

<style lang="scss" scoped>
.lesson-section-video {
  max-width: 50em;
  margin: auto;

  @media (max-width: 35rem) {
    margin: 0 -2em;
    width: calc(100% + 4em);
  }
}
</style>
